<!-- ConfirmDeleteDialog.vue -->
<script setup>
import {computed} from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';

const props = defineProps({
  modelValue: {type: Boolean, default: false},
  title: {type: String, default: 'Löschen bestätigen'},
  message: {type: String, default: 'Möchtest du wirklich löschen?'},
  details: {type: Array, default: () => []}, // [{label, value}]
  confirmLabel: {type: String, default: 'Löschen'},
  cancelLabel: {type: String, default: 'Abbrechen'},
  loading: {type: Boolean, default: false},
});

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel']);

const visible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
});

function onCancel() {
  emit('cancel');
  visible.value = false;
}

async function onConfirm() {
  emit('confirm');
}
</script>

<template>
  <Dialog
    v-model:visible="visible"
    modal
    :header="title"
    :closable="!loading"
    :dismissable-mask="!loading"
    :style="{maxWidth: '640px', width: 'calc(100% - 32px)'}"
  >
    <p class="m-0">
      {{ message }}
    </p>

    <div
      v-if="details?.length"
      class="mt-12"
    >
      <div
        class="card"
        style="padding: 12px;"
      >
        <div
          v-for="(d, idx) in details"
          :key="idx"
          style="display: grid; grid-template-columns: 100px 1fr; gap: 8px; align-items: start;"
        >
          <div
            class="muted font-bold"
            style="font-size: 12px; line-height: 16px;"
          >
            {{ d.label }}:
          </div>
          <div style="font-size: 14px; line-height: 20px; word-break: break-word;">
            {{ d.value || '—' }}
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <Button
        :label="cancelLabel"
        severity="secondary"
        :disabled="loading"
        @click="onCancel"
      />
      <Button
        :label="confirmLabel"
        severity="danger"
        :loading="loading"
        @click="onConfirm"
      />
    </template>
  </Dialog>
</template>